@if (loanInfo) {
  <!-- TODO fix this -->
  <!--  <p-message styleClass="mb-3" [id]="loanProgramError.messageServiceKey" [key]="loanProgramError.messageServiceKey"></p-message>-->
  @if (showAppraisalValueWarning) {
    <p-message severity="warn" class="warn2 mb-3">
      <div class="d-flex align-items-center">
        <i class="pi pi-exclamation-triangle fs-4 me-2"></i>
        <div>{{ appraisalValueWarning }}</div>
      </div>
    </p-message>
  }
  <form [formGroup]="mortgageTypeForm">
    <div class="row align-items-baseline">
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'loanPurpose' | qaSlug">
        <label class="control-label">Purpose of Loan <span class="color-danger">*</span></label>
        <p-select
          id="loanPurpose"
          class="w-100"
          formControlName="loanPurpose"
          [options]="purposeOfLoanOptions"
          optionLabel="name"
          optionValue="value"
          placeholder="Select"
          appendTo="body"
        />
        <cmg-validator-messages [control]="mortgageTypeForm.get('loanPurpose')" />
      </div>
      @if (showRefinancePurpose$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2">
          <label class="control-label">Refinance Type <span class="color-danger">*</span></label>
          @switch ((loanInfo$ | async).mortgageAppliedFor) {
            @case (1) {
              <ng-container [ngTemplateOutlet]="refinancePurposeTemplate" [ngTemplateOutletContext]="{ formControl: 'refinancePurposeVa' }" />
            }
            @case (2) {
              <ng-container [ngTemplateOutlet]="refinancePurposeTemplate" [ngTemplateOutletContext]="{ formControl: 'refinancePurposeFha' }" />
            }
            @default {
              <ng-container [ngTemplateOutlet]="refinancePurposeTemplate" [ngTemplateOutletContext]="{ formControl: 'refinancePurposeAu' }" />
            }
          }
          <ng-template #refinancePurposeTemplate let-name="formControl">
            <div [attr.automation-id]="name | qaSlug">
              <p-select
                id="{{ name }}"
                class="w-100"
                formControlName="{{ name }}"
                [options]="refinancePurposeOptions"
                optionLabel="name"
                optionValue="value"
                placeholder="Select"
                appendTo="body"
              >
                <ng-template let-option #item>
                  <span [class.hidden-option]="option.isHidden">{{ option.name }}</span>
                </ng-template>
              </p-select>
            </div>
            <cmg-validator-messages [control]="mortgageTypeForm.get(name)" />
          </ng-template>
        </div>
      }
      @if (
        (isFhaRefi$ | async) && (mortgageTypeForm.get('refinancePurposeFha').value === 1 || mortgageTypeForm.get('refinancePurposeFha').value === 2)
      ) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'fhaPreviousEndorsementDate' | qaSlug">
          <label class="control-label">FHA Previous Loan Case No Endorsement<span class="color-danger">*</span></label>
          <p-datepicker
            id="{{ uniqueId + '-fhaPreviousEndorsementDate' }}"
            styleClass="w-100"
            formControlName="fhaPreviousEndorsementDate"
            [showIcon]="true"
            placeholder="MM/DD/YYYY"
            cmg-input-error
            cmg-date-mask
            appendTo="body"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('fhaPreviousEndorsementDate')" />
        </div>
      }
      @if (isFundingFee$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'fundingFeeType' | qaSlug">
          <label class="control-label">Funding Fee Type<span class="color-danger">*</span></label>
          <p-select
            id="fundingFeeType"
            class="w-100"
            formControlName="fundingFeeType"
            [options]="fundingFeeOptions"
            optionLabel="name"
            optionValue="value"
            placeholder="Select"
            appendTo="body"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('fundingFeeType')" />
        </div>
      }
      <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6 mb-2 align-self-end" [attr.automation-id]="'isHomeFundItLoan' | qaSlug">
        <div class="checkbox-container">
          <p-checkbox formControlName="isHomeFundItLoan" [inputId]="'isHomeFundItLoan' | qaSlug" [binary]="true" class="me-3 mb-2" />
          <label [for]="'isHomeFundItLoan' | qaSlug">HomeFundIt Loan</label>
        </div>
      </div>
      @if (showRefinancePurposeCashOut$ | async) {
        <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6 mb-2 align-self-end" [attr.automation-id]="'refinancePurposeCashOut' | qaSlug">
          <label class="control-label">Refinance Purpose <span class="color-danger">*</span></label>
          <p-select
            id="refinancePurposeAu"
            class="w-100"
            formControlName="refinancePurposeAu"
            [options]="refinancePurposeCashOutOptions"
            [optionLabel]="'name'"
            [optionValue]="'value'"
            placeholder="Select"
            appendTo="body"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('refinancePurposeAu')" />
        </div>
      }
    </div>
    <div class="row align-items-baseline">
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2 mb-2" [attr.automation-id]="'mortgageAppliedFor' | qaSlug">
        <label class="control-label">Mortgage Type <span class="color-danger">*</span></label>
        <p-select
          id="mortgageAppliedFor"
          class="w-100"
          formControlName="mortgageAppliedFor"
          [options]="mortgageAppliedForOptions"
          optionLabel="name"
          optionValue="value"
          placeholder="Select"
          appendTo="body"
        />
        <cmg-validator-messages [control]="mortgageTypeForm.get('mortgageAppliedFor')" />
      </div>
      @if (isFha$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2 mb-2" [attr.automation-id]="'sectionOfAct' | qaSlug">
          <label class="control-label">Section of Act <span class="color-danger">*</span></label>
          <p-select
            id="sectionOfAct"
            class="w-100"
            formControlName="sectionOfAct"
            [options]="sectionOfActOptions"
            optionLabel="name"
            optionValue="value"
            placeholder="Select"
            appendTo="body"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('sectionOfAct')" />
        </div>
      }
      @if (isOther$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'otherMortgageDescription' | qaSlug">
          <label class="control-label">Other Mortgage Description</label>
          <input class="txt-box form-control" pInputText formControlName="otherMortgageDescription" maxlength="50" />
          <cmg-validator-messages [control]="mortgageTypeForm.get('otherMortgageDescription')" />
        </div>
      }
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'loanProgramCode' | qaSlug">
        <label class="control-label">Loan Program Code <span class="color-danger">*</span></label>
        <p-select
          id="loanProgramCode"
          class="w-100"
          formControlName="loanProgramCode"
          [options]="loanProgramCodeOptions$ | async"
          optionValue="value"
          optionLabel="label"
          placeholder="Select"
          [filter]="true"
          [virtualScroll]="true"
          virtualScrollItemSize="30"
          appendTo="body"
        />
        <cmg-validator-messages [control]="mortgageTypeForm.get('loanProgramCode')" />
      </div>
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'loanProgramName' | qaSlug">
        <label class="control-label">Loan Program Description <span class="color-danger">*</span></label>
        <p-select
          id="loanProgramName"
          class="w-100"
          formControlName="loanProgramName"
          [options]="loanProgramNameOptions$ | async"
          optionValue="value"
          optionLabel="label"
          placeholder="Select"
          [filter]="true"
          appendTo="body"
        />
        <cmg-validator-messages [control]="mortgageTypeForm.get('loanProgramName')" />
      </div>
      @if (isConventional$ | async) {
        <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6 mb-2 align-self-end" [attr.automation-id]="'isJumbo' | qaSlug">
          <div class="checkbox-container">
            <p-checkbox formControlName="isJumbo" [inputId]="'isJumbo' | qaSlug" [binary]="true" class="me-3 mb-2" />
            <label [for]="'isJumbo' | qaSlug">Jumbo Loan</label>
          </div>
        </div>
      }
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'amortizationType' | qaSlug">
        <label class="control-label">Amortization Type</label>
        <p-select
          class="w-100"
          formControlName="amortizationType"
          [options]="amortizationTypeOptions"
          optionLabel="name"
          optionValue="value"
          placeholder="Select"
          dropdownIcon="none"
          appendTo="body"
        />
        <cmg-validator-messages [control]="mortgageTypeForm.get('amortizationType')" />
      </div>
      @if (showAmortizationTypeDescription$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'amortizationTypeDescription' | qaSlug">
          <label class="control-label">Amortization Type Description</label>
          <input class="txt-box form-control" pInputText formControlName="amortizationTypeDescription" />
          <cmg-validator-messages [control]="mortgageTypeForm.get('amortizationTypeDescription')" />
        </div>
      }
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'positiveRentalHistory' | qaSlug">
        <label class="control-label">Positive Rental History</label>
        <p-select
          class="w-100"
          [pTooltip]="positiveRentalHistoryTooltipText"
          formControlName="positiveRentalHistory"
          [options]="positiveRentalHistoryOptions"
          [disabled]="isFha$ | async"
          optionLabel="name"
          optionValue="value"
          placeholder="Select"
          appendTo="body"
        />
        <cmg-validator-messages [control]="mortgageTypeForm.get('amortizationType')" />
      </div>
    </div>
    @if ((loanInfo$ | async)?.amortizationType === AmortizationType.NoPayment) {
      <div>
        <div class="row align-items-baseline mt-3">
          <div class="col col-md-8 col-lg-6 col-xl-4" [attr.automation-id]="'isNegativeAmortization' | qaSlug">
            <div class="checkbox-container">
              <p-checkbox [binary]="true" formControlName="isNegativeAmortization" inputId="isNegativeAmortization" />
              <label class="control-label">Is 'Negative Amortization Loan' under TILA (applies to non-TRID Loans only)</label>
            </div>
            <i
              class="fas fa-info-circle ms-3 color-primary pb-3"
              pTooltip="When checked, this loan is considered to be a negative amortization
             loan under 12 CFR §1026.18(s)(7)(v) which states in part: [T]he term 'negative amortization loan' means a loan,
             other than a reverse mortgage subject to §1026.33, that provides for a minimum periodic payment that covers only
              a portion of the accrued interest, resulting in negative amortization."
              tooltipPosition="right"
              tooltipEvent="hover"
            ></i>
          </div>
        </div>
        <div class="row align-items-baseline">
          <div class="col col-md-8 col-lg-6 col-xl-4 mb-3" [attr.automation-id]="'isGrantLoan' | qaSlug">
            <div class="checkbox-container">
              <p-checkbox [binary]="true" formControlName="isGrantLoan" [inputId]="'isGrantLoan' | qaSlug" />
              <label [for]="'isGrantLoan' | qaSlug">Is Grant (Principle is Forgiven at the end of the Term)</label>
            </div>
          </div>
        </div>
      </div>
    }
    @if (showQualRateOption$ | async) {
      <div class="row align-items-baseline">
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2 mb-2" [attr.automation-id]="'armQualRateOption' | qaSlug">
          <label class="control-label"
            >Qual Rate Option
            <span class="color-danger">*</span>
          </label>
          <p-select
            id="armQualRateOption"
            class="w-100"
            formControlName="armQualRateOption"
            [options]="qualRateOptions"
            optionLabel="name"
            optionValue="value"
            placeholder="Select"
            appendTo="body"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('armQualRateOption')" />
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'intOnlyQualPaymentCalcOption' | qaSlug">
          <label class="control-label"
            >Interest Only Qualifying Payment Option
            <span class="color-danger">*</span>
          </label>
          <p-select
            id="intOnlyQualPaymentCalcOption"
            class="w-100"
            formControlName="intOnlyQualPaymentCalcOption"
            [options]="intOnlyQualPaymentOptions"
            optionLabel="name"
            optionValue="value"
            placeholder="Select"
            appendTo="body"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('intOnlyQualPaymentCalcOption')" />
        </div>
      </div>
    }
    <hr />
    <div class="row align-items-baseline">
      @if (showAfterImpValue$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'afterImprovedValue' | qaSlug">
          <label class="control-label">After-Imp. Value</label>
          <p-inputNumber
            class="w-100"
            styleClass="form-control input-span"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            [max]="maxCurrencyValue"
            maxlength="14"
            mode="currency"
            currency="USD"
            locale="en-US"
            formControlName="afterImprovedValue"
            placeholder="$0.00"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('afterImprovedValue')" />
        </div>
      }
      @if (isFha$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'caseNumberAssignedDate' | qaSlug">
          <label class="control-label">FHA Case No Assigned</label>
          <p-select
            class="w-100"
            formControlName="caseNumberAssignedDate"
            [options]="caseNumberAssignedDateOptions"
            optionLabel="name"
            optionValue="value"
            placeholder="Select"
            appendTo="body"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('caseNumberAssignedDate')" />
        </div>
      }
      @if (isUSDA$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'gusFirstRunDate' | qaSlug">
          <label class="control-label">USDA Case No Assigned</label>
          <p-select
            class="w-100"
            formControlName="gusFirstRunDate"
            [options]="gusRunFirstDateOptions"
            optionLabel="name"
            optionValue="value"
            placeholder="Select"
            appendTo="body"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('gusFirstRunDate')" />
        </div>
      }
      @if (showTexasA6Status) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'texasA6Status' | qaSlug">
          <label class="control-label"
            >Texas A6 Status
            <span class="color-danger"
              >*<i
                class="fas fa-info-circle ms-1 color-primary"
                pTooltip="Indicates the Texas A6 status of the previous and new loan"
                tooltipPosition="right"
                tooltipEvent="hover"
              ></i></span
          ></label>
          <p-select
            class="w-100"
            formControlName="texasA6Status"
            [options]="texasA6StatusOptions"
            [optionLabel]="'name'"
            [optionValue]="'id'"
            placeholder="Select"
            appendTo="body"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('texasA6Status')" />
        </div>
      }
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'loanTerm' | qaSlug">
        <label class="control-label">Loan Term (in Months) <span class="color-danger">*</span></label>
        <p-inputNumber id="loanTerm" class="w-100" styleClass="form-control input-span" [max]="99999" formControlName="loanTerm" />
        <cmg-validator-messages [control]="mortgageTypeForm.get('loanTerm')" />
      </div>
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'balloonTerm' | qaSlug">
        <label class="control-label">Due In</label>
        <p-inputNumber id="balloonTerm" class="w-100" styleClass="form-control input-span" formControlName="balloonTerm" />
      </div>
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'interestRate' | qaSlug">
        <label class="control-label">Interest Rate <span class="color-danger">*</span></label>
        <cmg-decimal-input
          id="interestRate"
          class="w-100"
          styleClass="form-control input-span"
          formControlName="interestRate"
          placeholder="0.000"
          fractionDigits="3"
          type="percent"
          max="100"
          min="0"
        />
        <cmg-validator-messages [control]="mortgageTypeForm.get('interestRate')" />
      </div>
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'qualRate' | qaSlug">
        <label class="control-label">Qual Rate</label>
        <cmg-decimal-input
          id="qualRate"
          formControlName="qualRate"
          placeholder="0.000"
          fractionDigits="3"
          type="percent"
          class="w-100"
          cmgFormControlFactorReset
        />
        <cmg-validator-messages [control]="mortgageTypeForm.get('qualRate')" />
      </div>
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'interestOnlyPeriod' | qaSlug">
        <label class="control-label">Interest Only Period (Months)</label>
        <p-inputNumber class="w-100" styleClass="form-control input-span" [max]="999" formControlName="interestOnlyPeriod" />
        <cmg-validator-messages [control]="mortgageTypeForm.get('interestOnlyPeriod')" />
      </div>
      @if (isFha$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'fhaExpectedEndorsementDate' | qaSlug">
          <label class="control-label ellipsis">FHA New Loan Expected Endorsement Date<span class="color-danger">*</span></label>
          <p-datepicker
            id="{{ uniqueId + '-fhaExpectedEndorsementDate' }}"
            styleClass="w-100"
            formControlName="fhaExpectedEndorsementDate"
            [showIcon]="true"
            placeholder="MM/DD/YYYY"
            cmg-input-error
            cmg-date-mask
            appendTo="body"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('fhaExpectedEndorsementDate')" />
        </div>
      }
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'waiveEscrow' | qaSlug">
        <label class="control-label">Escrow Waiver</label>
        <p-select
          id="waiveEscrow"
          class="w-100"
          formControlName="waiveEscrow"
          [options]="escrowsOptions"
          optionLabel="name"
          optionValue="value"
          placeholder="Select"
          appendTo="body"
        />
        <cmg-validator-messages [control]="mortgageTypeForm.get('waiveEscrow')" />
      </div>
    </div>
    <div class="row align-items-baseline">
      @if (showConstructionFields$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'landLoanStatus' | qaSlug">
          <label class="control-label">Land Loan Status</label>
          <p-select
            id="landLoanStatus"
            class="w-100"
            formControlName="landLoanStatus"
            [options]="landLoanStatusOptions"
            optionLabel="name"
            optionValue="id"
            placeholder="Select"
            appendTo="body"
          />
        </div>
      }
      @if (showConstructionFields$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'constructionPurpose' | qaSlug">
          <label class="control-label">Construction Purpose</label>
          <p-select
            id="constructionPurpose"
            class="w-100"
            formControlName="constructionPurpose"
            [options]="constructionPurposeOptions"
            optionLabel="name"
            optionValue="id"
            placeholder="Select"
            appendTo="body"
          />
        </div>
      }
      @if (showOtherPurposeDescription$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'otherPurposeDescription' | qaSlug">
          <label class="control-label">Other Purpose Description</label>
          <input class="txt-box form-control" pInputText formControlName="otherPurposeDescription" maxlength="50" />
          <cmg-validator-messages [control]="mortgageTypeForm.get('otherPurposeDescription')" />
        </div>
      }
      @if (is2ndG01LoanProgram$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'minimumDrawAmount' | qaSlug">
          <label class="control-label text-wrap ow-break-word">Minimum Draw Amount <span class="color-danger">*</span></label>
          <p-inputNumber
            id="minimumDrawAmount"
            [disabled]="disableMinimumDrawAmount$"
            class="w-100"
            styleClass="form-control input-span"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            min="25000"
            [max]="maxCurrencyValue"
            maxlength="14"
            mode="currency"
            currency="USD"
            locale="en-US"
            formControlName="minimumDrawAmount"
            placeholder="$0.00"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('minimumDrawAmount')" />
          <div class="validation-text">Must be greater than or equal to $25,000</div>
        </div>
      }
      @if (isHeloc$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'aioInitialDrawAmount' | qaSlug">
          <label class="control-label text-wrap">Total Initial Advance at Closing (Draw Amount)</label>
          <p-inputNumber
            id="aioInitialDrawAmount"
            class="w-100"
            styleClass="form-control input-span"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            [min]="(is2ndG01LoanProgram$ | async) === true ? 18750 : 0"
            [max]="maxCurrencyValue"
            maxlength="14"
            mode="currency"
            currency="USD"
            locale="en-US"
            formControlName="aioInitialDrawAmount"
            placeholder="$0.00"
          />
          <!-- Where this message says "Total Loan Amount", it is referring to the "Minimum Draw Amount" -->
          @if (is2ndG01LoanProgram$ | async) {
            <div class="validation-text">Must be the lesser of $50,000 or 75% of the Total Loan Amount</div>
          }
          @if ((is2ndG01LoanProgram$ | async) !== true) {
            <cmg-validator-messages [control]="mortgageTypeForm.get('aioInitialDrawAmount')" />
          }
        </div>
      }
      @if (isHeloc$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'armLifeCap' | qaSlug">
          <label class="control-label">Life Cap</label>
          <cmg-decimal-input
            id="armLifeCap"
            formControlName="armLifeCap"
            placeholder="0.000"
            fractionDigits="3"
            type="percent"
            max="100"
            min="0"
            styleClass="form-control input-span w-100"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('armLifeCap')" />
        </div>
      }
    </div>
    <hr />
    <div class="row align-items-baseline">
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'appraisalValue' | qaSlug">
        <label class="control-label">Appraisal Value <span class="color-danger">*</span></label>
        <p-inputNumber
          id="appraisalValue"
          class="w-100"
          styleClass="form-control input-span"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [max]="maxCurrencyValue"
          mode="currency"
          currency="USD"
          locale="en-US"
          maxlength="14"
          formControlName="appraisalValue"
          placeholder="$0.00"
          (onBlur)="handleAppraisalValueWarning()"
        />
        @if (showAppraisalValueHelper) {
          <div class="text-color-secondary fs-sm">Appraisal Value and Sales Price / Estimated Value do not match!</div>
        }
        <cmg-validator-messages [control]="mortgageTypeForm.get('appraisalValue')" />
      </div>
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'salesPrice' | qaSlug">
        <label class="control-label">Sales Price / Estimated Value <span class="color-danger">*</span></label>
        <p-inputNumber
          id="salesPrice"
          class="w-100"
          styleClass="form-control input-span"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [max]="maxCurrencyValue"
          mode="currency"
          currency="USD"
          locale="en-US"
          maxlength="14"
          formControlName="salesPrice"
          placeholder="$0.00"
          (onBlur)="updateSalesPrice(); handleAppraisalValueWarning()"
        />
        <cmg-validator-messages [control]="mortgageTypeForm.get('salesPrice')" />
      </div>
      @if (isFha$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'maxLoanLimitByCounty' | qaSlug">
          <label class="control-label">Max County Loan Limit</label>
          <p-inputNumber
            id="maxLoanLimitByCounty"
            class="w-100"
            styleClass="form-control input-span"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            [max]="maxCurrencyValue"
            mode="currency"
            currency="USD"
            locale="en-US"
            maxlength="14"
            formControlName="maxLoanLimitByCounty"
            placeholder="$0.00"
          />
        </div>
      }
    </div>
    <div class="row align-items-baseline">
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'dpfactor' | qaSlug">
        <label class="control-label">DP Factor</label>
        <p-select
          class="w-100"
          formControlName="dpfactor"
          [options]="dpFactorOptions"
          optionLabel="name"
          optionValue="value"
          placeholder="Select"
          appendTo="body"
        />
        <cmg-validator-messages [control]="mortgageTypeForm.get('dpfactor')" />
      </div>
      @if (showDownPaymentPercentage$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'downPaymentPercentage' | qaSlug">
          <label class="control-label">Down Payment %</label>
          <cmg-decimal-input
            id="downPaymentPercentage"
            formControlName="downPaymentPercentage"
            placeholder="0.000"
            fractionDigits="3"
            [roundToFractionDigits]="true"
            type="percent"
            max="999"
            min="0"
            styleClass="form-control input-span w-100"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('downPaymentPercentage')" />
        </div>
      }
      @if (showDownPaymentAmount$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'downPaymentAmount' | qaSlug">
          <label class="control-label">Down Payment $</label>
          <p-inputNumber
            class="w-100"
            styleClass="form-control input-span"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            [max]="maxCurrencyValue"
            maxlength="14"
            mode="currency"
            currency="USD"
            locale="en-US"
            formControlName="downPaymentAmount"
            placeholder="$0.00"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('downPaymentAmount')" />
        </div>
      }
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'baseLoanAmount' | qaSlug">
        <label class="control-label">Base Loan Amount <span class="color-danger">*</span></label>
        <p-inputNumber
          id="baseLoanAmount"
          class="w-100"
          styleClass="form-control input-span"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [max]="maxBaseLoanAmount"
          maxlength="14"
          mode="currency"
          currency="USD"
          locale="en-US"
          formControlName="baseLoanAmount"
          placeholder="$0.00"
        />
        <cmg-validator-messages [control]="mortgageTypeForm.get('baseLoanAmount')" />
      </div>
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'totalLoanAmount' | qaSlug">
        <label class="control-label">Note Loan Amount</label>
        <p-inputNumber
          class="w-100"
          styleClass="form-control input-span"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [max]="maxCurrencyValue"
          maxlength="14"
          mode="currency"
          currency="USD"
          locale="en-US"
          formControlName="totalLoanAmount"
          placeholder="$0.00"
        />
        <cmg-validator-messages [control]="mortgageTypeForm.get('totalLoanAmount')" />
      </div>
    </div>
    <hr />
    <div class="row align-items-baseline mb-3">
      @if (showPmiType$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'pmiType' | qaSlug">
          <label class="control-label">PMI Type</label>
          <p-select
            class="w-100"
            formControlName="pmiType"
            [options]="pmiTypeOptions"
            optionLabel="name"
            optionValue="value"
            placeholder="Select"
            appendTo="body"
            (onChange)="onPmiTypeChange($event)"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('pmiType')" />
        </div>
      }
      @if (showMonthlyMI$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'monthlyMiFactor' | qaSlug">
          <label class="control-label">Monthly MI Factor</label>
          <cmg-decimal-input
            id="monthlyMiFactor"
            formControlName="monthlyMiFactor"
            placeholder="0.000"
            fractionDigits="3"
            type="percent"
            class="w-100"
            cmgFormControlFactorReset
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('monthlyMiFactor')" />
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'monthlyMiAmount' | qaSlug">
          <label class="control-label">Monthly MI Amount</label>
          <p-inputNumber
            class="w-100"
            styleClass="form-control input-span"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            [max]="maxCurrencyValue"
            maxlength="14"
            mode="currency"
            currency="USD"
            locale="en-US"
            formControlName="monthlyMiAmount"
            placeholder="$0.00"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('monthlyMiAmount')" />
        </div>
      }
      @if (showMonthlyMIPaidInCash$ | async) {
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'miPaidInCash' | qaSlug">
          <label class="control-label">MI Paid in Cash</label>
          <p-inputNumber
            class="w-100"
            styleClass="form-control input-span"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            [max]="maxCurrencyValue"
            maxlength="14"
            mode="currency"
            currency="USD"
            locale="en-US"
            formControlName="miPaidInCash"
            placeholder="$0.00"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('miPaidInCash')" />
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'upfrontMiFactor' | qaSlug">
          <label class="control-label">Upfront MI Factor</label>
          <cmg-decimal-input
            id="upfrontMiFactor"
            formControlName="upfrontMiFactor"
            placeholder="0.000"
            fractionDigits="3"
            type="percent"
            max="100"
            min="0"
            class="w-100"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('upfrontMiFactor')" />
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'upfrontMiAmount' | qaSlug">
          <label class="control-label">Upfront MI Amount</label>
          <p-inputNumber
            class="w-100"
            styleClass="form-control input-span"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            [max]="maxBaseLoanAmount"
            maxlength="14"
            mode="currency"
            currency="USD"
            locale="en-US"
            formControlName="upfrontMiAmount"
            placeholder="$0.00"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('upfrontMiAmount')" />
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'mipffFinancingCalcOption' | qaSlug">
          <label class="control-label">Upfront MI Type</label>
          <p-select
            class="w-100"
            formControlName="mipffFinancingCalcOption"
            [options]="upfrontMiTypeOptions"
            optionLabel="name"
            optionValue="value"
            appendTo="body"
          />
          <cmg-validator-messages [control]="mortgageTypeForm.get('mipffFinancingCalcOption')" />
        </div>
      }
    </div>
    <!--isFundingFee-->
    @if (isFundingFee$ | async) {
      <p-divider />
      <div class="row align-items-baseline mb-2">
        <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
          <label class="block">
            Are you classified as a disabled veteran?
            <span class="color-danger">*</span>
          </label>
          <div>
            <span [attr.automation-id]="'areYouDisabledVeteranYes' | qaSlug">
              <div class="radiobutton-container">
                <p-radiobutton
                  name="areYouDisabledVeteran"
                  class="me-1"
                  [value]="true"
                  formControlName="areYouDisabledVeteran"
                  inputId="areYouDisabledVeteranYes"
                />
                <label class="control-label" for="areYouDisabledVeteranYes">Yes</label>
              </div>
            </span>
            <span [attr.automation-id]="'areYouDisabledVeteranNo' | qaSlug">
              <div class="radiobutton-container">
                <p-radiobutton
                  name="areYouDisabledVeteran"
                  class="mx-1"
                  [value]="false"
                  formControlName="areYouDisabledVeteran"
                  inputId="areYouDisabledVeteranNo"
                />
                <label class="control-label" for="areYouDisabledVeteranNo">No</label>
              </div>
            </span>
          </div>
        </div>
        @if (showHomeOwnedThroughVa$ | async) {
          <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
            <label class="block">
              Have you ever owned a home financed through VA?
              <span class="color-danger">*</span>
            </label>
            <div>
              <span [attr.automation-id]="'homeOwnedThroughVaYes' | qaSlug">
                <div class="radiobutton-container">
                  <p-radiobutton
                    name="homeOwnedThroughVa"
                    class="me-1"
                    [value]="true"
                    formControlName="homeOwnedThroughVa"
                    inputId="homeOwnedThroughVaYes"
                  />
                  <label class="control-label" for="homeOwnedThroughVaYes">Yes</label>
                </div>
              </span>
              <span [attr.automation-id]="'homeOwnedThroughVaNo' | qaSlug">
                <div class="radiobutton-container">
                  <p-radiobutton
                    name="homeOwnedThroughVa"
                    class="mx-1"
                    [value]="false"
                    formControlName="homeOwnedThroughVa"
                    inputId="homeOwnedThroughVaNo"
                  />
                  <label class="control-label" for="homeOwnedThroughVaNo">No</label>
                </div>
              </span>
            </div>
          </div>
        }
      </div>
    }
  </form>
}
